module.exports = __webpack_public_path__ + "img/logo.7d9bd97d.jpg";